export default function Team() {
  return (
    <section className="py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#0066CC]/10 rounded-full text-[#0066CC] text-sm font-semibold mb-6">
            FOUNDER
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Meet the CEO and Founder Behind the Company
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Bringing combined experience in technology, security, business transformation, and military service.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="text-center max-w-4xl">
            <div className="w-80 h-[500px] mx-auto mb-6 rounded-2xl overflow-hidden shadow-lg">
              <img 
                src="https://static.readdy.ai/image/a9484c237c280a31654c8c92f5f19b1a/26fdb8839e774391603e8df418938fd3.png"
                alt="Adam Ussery - CEO and Founder"
                className="w-full h-full object-cover object-center"
              />
            </div>
            
            <div className="text-left space-y-4 text-gray-700 leading-relaxed">
              <p className="text-base">
                <strong>Adam Ussery</strong>
              </p>
              <p className="text-base">
                <strong>Founder & CEO, Patriot Defense Technologies LLC</strong>
              </p>
              <p className="text-base">
                Adam Ussery is a U.S. Army veteran, cybersecurity professional, and the Founder and CEO of Patriot Defense Technologies LLC. His career is rooted in service, discipline, and a mission-focused approach to protecting the organizations that keep the nation strong.
              </p>
              <p className="text-base">
                Adam served in the United States Army as a Combat Medic Non-Commissioned Officer, where he was responsible for the mission readiness, training, and success of the soldiers under his charge. During his military career, he deployed to Iraq in support of Operation Iraqi Freedom (OIF) and Operation Enduring Freedom (OEF). For his service, he received the Army Commendation Medal (ARCOM) along with other military awards. After being medically retired from the Army, he carried forward the values and leadership principles instilled in him during his time in uniform.
              </p>
              <p className="text-base">
                Following his military service, Adam began his career in Information Technology while working at a Managed Service Provider (MSP) and putting himself through college. His dedication and work ethic led him into the healthcare sector, where he joined a hospital system and advanced through multiple technical and leadership roles. Over the years, he progressed from the service desk to Analyst I, Analyst II, Analyst III, and ultimately to Manager of Integrations, Architecture, and Applications. In this role, he led complex system integrations, supported critical clinical and business systems, and helped ensure the reliability and security of essential healthcare technology.
              </p>
              <p className="text-base">
                Driven by his passion for technology, his respect for the men and women who serve, and his commitment to small businesses, Adam founded Patriot Defense Technologies LLC. The company is built on a mission to provide security-first IT services, cybersecurity, and compliance solutions to defense contractors, small businesses, and organizations within the Defense Industrial Base. His goal is to deliver the highest level of service, protection, and value to the clients who depend on secure and reliable technology to operate.
              </p>
              <p className="text-base">
                Adam's leadership philosophy is grounded in the Army values summarized by the acronym L.D.R.S.H.I.P.—Loyalty, Duty, Respect, Selfless Service, Honor, Integrity, and Personal Courage. These principles guide every decision he makes, both personally and professionally.
              </p>
              <p className="text-base">
                With faith, family, and patriotism as his foundation, Adam leads Patriot Defense Technologies with a clear mission: to deliver readiness, protection, and honor through trusted technology services. His work reflects a lifelong commitment to service—first to his fellow soldiers, and now to the businesses and organizations that support the nation's strength and security.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
